// Angular Imports
import { Injectable } from "@angular/core";

// Rxjs
import { catchError, Observable, of } from "rxjs";

// Custom Imports
import { environment } from "#src/environments/environment";
import { HttpService } from "#services/http/http.service";
import { Config, ConfigInList, ConfigInputFields, ConfigNames } from "#models/config";
import { HttpParams } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class ConfigService extends HttpService {
    baseApiUrl = `${environment.API_URL}/config`;
    config: string[] | string | boolean = false;

    // Get all configs
    getConfig(params: HttpParams): Observable<{ data: ConfigInList[]; meta: { total: number } }> {
        return this.http
            .get<{ data: ConfigInList[]; meta: { total: number } }>(this.baseApiUrl, { params })
            .pipe(
                catchError((err) => {
                    this.handleRequestError(err);
                    return of({ data: [], meta: { total: 0 } });
                })
            );
    }

    getConfigByName<T extends ConfigNames>(
        name: T,
        configs: { data: { key: string; value: string }[] }
    ): string[] | string | boolean | null {
        return configs.data.filter((config) => config.key === name)?.[0]?.value;
    }

    getConfigs() {
        return this.http
            .get<{ data: { key: string; value: string }[] | [] }>(`${this.baseApiUrl}/all`)
            .pipe(
                catchError((err) => {
                    this.handleRequestError(err);
                    return of({ data: [{ key: "", value: "" }] });
                })
            );
    }

    // Get a specific config by ID
    getConfigById(id: number): Observable<{ data: Config }> {
        return this.http
            .get<{ data: Config }>(`${this.baseApiUrl}/${id}`)
            .pipe(catchError(this.handleRequestError.bind(this)));
    }

    // Update a config by ID
    updateConfig(id: number, newValues: ConfigInputFields): Observable<{ data: Config }> {
        return this.http.put<{ data: Config }>(`${this.baseApiUrl}/${id}`, newValues).pipe(
            catchError((error) => {
                this.handleRequestError(error);
                const defaultValues: { data: Config } = {
                    data: {
                        id: 0,
                        value: "",
                        type: "string",
                        key: "",
                        description: "",
                        updated_at: "",
                        is_system: false,
                        validation: "",
                    },
                };
                return of(defaultValues);
            })
        );
    }
}
